export default "__VITE_ASSET__DHUaba7A__"